import { SystemUsersPage } from '@hq/sys-admin';
import { hq, useAuthStore } from '../session';

/**
 * 用户与权限（平台侧跨租户，门禁 sys:user:view / sys:role:manage）。
 * 页面实现收敛在 `@hq/sys-admin`，本端开启租户维度与「所属租户」列。
 */
export default function SystemUsers() {
  const level = useAuthStore((state) => state.profile?.level);
  return <SystemUsersPage platform hq={hq} viewerLevel={level} />;
}
